/**
 * Comment Store (Zustand)
 *
 * Replaces CommentContext.
 * Manages active comment thread tracking and thread expansion state.
 */

import {create} from 'zustand';

// ─── Types ───────────────────────────────────────────────────────────────────

export interface CommentState {
  activeCommentNodeId: string | null;
  expandedThreads: Record<string, boolean>;
}

export interface CommentActions {
  setActiveCommentNodeId: (id: string | null) => void;
  toggleThread: (threadId: string) => void;
}

// ─── Store ───────────────────────────────────────────────────────────────────

export const useCommentStore = create<CommentState & CommentActions>()(
  (set) => ({
    activeCommentNodeId: null,
    expandedThreads: {},

    setActiveCommentNodeId: (id) => {
      set({activeCommentNodeId: id});
    },

    toggleThread: (threadId) => {
      set((s) => ({
        expandedThreads: {
          ...s.expandedThreads,
          [threadId]: !s.expandedThreads[threadId]
        }
      }));
    }
  })
);
